import { render, staticRenderFns } from "./remarkAction.vue?vue&type=template&id=4bd542ba&scoped=true"
import script from "./remarkAction.vue?vue&type=script&lang=js"
export * from "./remarkAction.vue?vue&type=script&lang=js"
import style0 from "./remarkAction.vue?vue&type=style&index=0&id=4bd542ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd542ba",
  null
  
)

export default component.exports